module.exports = __webpack_public_path__ + "img/8.cc3301f6.png";